<div class="content-max-width steps-helper">
  <app-step-header-step *ngFor="let step of steps" [stepItem]="step"></app-step-header-step>
</div>
